import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=22d50513&"
import script from "./avatar.vue?vue&type=script&lang=ts&"
export * from "./avatar.vue?vue&type=script&lang=ts&"
import style0 from "./avatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports